import { Radar } from "react-chartjs-2";

const { forwardRef, useState, useEffect, useImperativeHandle, useRef } = require("react");

const RadarChart = forwardRef(({ scores }, ref) => {
    const chartRef = useRef(null)
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [],
    })

    useEffect(() => {
        if (scores && Object.keys(scores).length) {
            const allLabels = [
                "BEARING MOUNTING",
                "BEARING DISMOUNTING",
                "LUBRICATION MANAGEMENT",
                "SHAFT AND BELT/CHAIN ALIGNMENT",
                "CONDITION MONITORING",
            ];

            // Fill in missing labels with 0
            const userScores = allLabels.map(label => parseFloat(scores[label]) || 0);

            const data = {
                labels: allLabels,
                datasets: [
                    {
                        label: "Your Scores",
                        data: userScores,
                        borderColor: "rgba(30, 90, 180, 1)",
                        backgroundColor: "transparent",
                        borderWidth: 2,
                    },
                    {
                        label: "Industry Average",
                        data: allLabels.map(() => 60),
                        borderColor: "rgba(220, 120, 50, 1)",
                        backgroundColor: "transparent",
                        borderWidth: 2,
                    },
                    {
                        label: "Segment Average",
                        data: allLabels.map(() => 40),
                        borderColor: "rgba(120, 120, 120, 1)",
                        backgroundColor: "transparent",
                        borderWidth: 2,
                    },
                ],
            };

            setChartData(data);
        }
    }, [scores]);


    useImperativeHandle(ref, () => ({
        getImage: () =>
            new Promise((resolve, reject) => {
                const checkImage = () => {
                    try {
                        const image = chartRef.current?.toBase64Image("image/png", 1.0);
                        if (image && image.startsWith("data:image")) {
                            resolve(image);
                        } else {
                            setTimeout(checkImage, 100);
                        }
                    } catch (error) {
                        reject(error);
                    }
                };

                checkImage();
            }),

    }));

    const options = { scales: { r: { min: 0, max: 100, ticks: { stepSize: 10 }, }, }, plugins: { legend: { position: "top" }, }, responsive: true, };

    return (
        <div>
            <Radar ref={chartRef} data={chartData} options={options} style={{ width: "500px", height: "600px" }} />
        </div>
    )
})

export default RadarChart;